// extracted by mini-css-extract-plugin
export default {"container":"stats-panel_container__lExr+","title":"stats-panel_title__875xQ","count":"stats-panel_count__6apgo"};